import { Cart } from "@/types";
import { atom } from "jotai";

/**
 * Factory for a fresh empty cart. Always returns NEW nested objects/arrays so
 * callers that "clear" the cart never alias a shared module constant (a latent
 * corruption hazard if any future code mutates items in place).
 */
export function createEmptyCart(): Cart {
  return {
    items: [],
    totalPrice: 0,
    estimateTakeoutTime: 0,
  }
}

export const initialValueCart: Cart = createEmptyCart()

const cartAtom = atom<Cart>(createEmptyCart())

export default cartAtom
